interface LocalStorage {
  getItem: (item: string) => string | null
  setItem: (item: string, value: any) => void
  removeItem: (item: string) => void
}

const safeStorage: LocalStorage = {
  getItem: item => {
    try {
      return localStorage.getItem(item)
    } catch (e) {
      return null
    }
  },
  setItem: (item, value) => {
    try {
      return localStorage.setItem(item, value)
    } catch (e) {
      return null
    }
  },
  removeItem: item => {
    try {
      return localStorage.removeItem(item)
    } catch (e) {
      return null
    }
  },
}

export default safeStorage
